var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyFolderPageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 391,
    viewBox: "0 0 392 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M284.653 242.569C288.212 235.021 291.411 226.545 298.808 222.659C306.279 218.735 315.224 220.564 323.521 222.152C331.68 223.713 339.757 226.072 345.89 231.67C352.278 237.5 356.809 245.252 358.173 253.781C359.55 262.394 357.327 271.052 353.436 278.856C349.468 286.816 343.913 294.093 336.02 298.213C327.999 302.4 318.608 303.537 309.747 301.661C301.096 299.83 293.483 294.744 287.775 287.999C282.341 281.579 279.375 273.478 278.799 265.098C278.254 257.161 281.261 249.764 284.653 242.569Z",
    fill: "#123133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.1917 140.409C51.0668 101.937 85.2735 76.0514 121.87 58.5986C157.587 41.5652 197.265 35.7848 235.409 46.3567C275.646 57.5089 315.067 79.372 332.991 117.113C350.643 154.283 338.22 196.549 325.283 235.598C312.358 274.611 296.842 315.435 260.775 335.091C223.829 355.225 178.667 351.968 139.359 336.92C101.812 322.547 74.0339 292.319 55.6218 256.555C36.9937 220.37 25.2798 178.991 38.1917 140.409Z",
    fill: "#ABDFD5",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M348.366 203.004C347.644 209.287 343.156 214.679 337.567 218.344C332 221.995 325.282 223.864 319.132 222.175C312.987 220.488 308.84 215.567 306.625 209.847C304.355 203.984 303.495 197.105 307.281 191.572C310.962 186.193 317.987 184.594 324.478 183.754C330.548 182.969 336.658 183.573 341.146 187.19C345.94 191.053 349.08 196.783 348.366 203.004Z",
    fill: "#FFB400"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyFolderPageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-folder-page-icon.75638afe8907c885f4863c18d1427ee1.svg";